export default "__VITE_ASSET__CRrgjtkp__"